"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CROSS_DEX = void 0;
exports.CROSS_DEX = [{
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'address',
    name: 'previousAdmin',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'newAdmin',
    type: 'address'
  }],
  name: 'AdminChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'beacon',
    type: 'address'
  }],
  name: 'BeaconUpgraded',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'uint8',
    name: 'version',
    type: 'uint8'
  }],
  name: 'Initialized',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'previousOwner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'OwnershipTransferred',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'receiverAddress',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'inTokenAddress',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'outTokenAddress',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'amountIn',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'amountOut',
    type: 'uint256'
  }],
  name: 'SwapSucceedEvent',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'implementation',
    type: 'address'
  }],
  name: 'Upgraded',
  type: 'event'
}, {
  inputs: [],
  name: 'claimOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'myint',
    type: 'uint256'
  }],
  name: 'initialize',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'owner',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'pendingOwner',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'proxiableUUID',
  outputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'uint256',
    name: 'amountIn_',
    type: 'uint256'
  }, {
    internalType: 'address',
    name: 'inTokenAddress_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'middleTokenAddress_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'outTokenAddress_',
    type: 'address'
  }, {
    internalType: 'address payable',
    name: 'receiverAddress_',
    type: 'address'
  }, {
    components: [{
      internalType: 'address',
      name: 'to',
      type: 'address'
    }, {
      internalType: 'bytes4',
      name: 'selector',
      type: 'bytes4'
    }, {
      internalType: 'uint256',
      name: 'value',
      type: 'uint256'
    }, {
      internalType: 'bytes[]',
      name: 'params',
      type: 'bytes[]'
    }, {
      internalType: 'bool',
      name: 'isReplace',
      type: 'bool'
    }, {
      internalType: 'uint8',
      name: 'index',
      type: 'uint8'
    }],
    internalType: 'struct CrossDex.CallInfo',
    name: 'swap1_',
    type: 'tuple'
  }, {
    components: [{
      internalType: 'address',
      name: 'to',
      type: 'address'
    }, {
      internalType: 'bytes4',
      name: 'selector',
      type: 'bytes4'
    }, {
      internalType: 'uint256',
      name: 'value',
      type: 'uint256'
    }, {
      internalType: 'bytes[]',
      name: 'params',
      type: 'bytes[]'
    }, {
      internalType: 'bool',
      name: 'isReplace',
      type: 'bool'
    }, {
      internalType: 'uint8',
      name: 'index',
      type: 'uint8'
    }],
    internalType: 'struct CrossDex.CallInfo',
    name: 'swap2_',
    type: 'tuple'
  }],
  name: 'swap',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'transferOwnership',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newImplementation',
    type: 'address'
  }],
  name: 'upgradeTo',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newImplementation',
    type: 'address'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'upgradeToAndCall',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  stateMutability: 'payable',
  type: 'receive'
}];
